import { useContext, createContext } from 'react';
export const SiteLanguageContext = /*#__PURE__*/createContext(undefined);
export const useSiteLanguage = () => useContext(SiteLanguageContext);
//# sourceMappingURL=site-language-context.js.map